import { atom, useAtomValue } from "jotai";

import { PackageOrder } from "../../PackageOrder";
import { CurrentPackagesModalAtom } from "../atoms";

export const CurrentPackageOrder = () => {
  const orderId = useAtomValue(orderIdAtom);
  const packageId = useAtomValue(packageIdAtom);
  return <PackageOrder packageId={packageId!} orderId={orderId!} />;
};

const orderIdAtom = atom((get) => {
  const state = get(CurrentPackagesModalAtom);
  if (state.page !== "order") return null;

  return state.orderId;
});

const packageIdAtom = atom((get) => {
  const state = get(CurrentPackagesModalAtom);
  if (state.page !== "order") return null;

  return state.packageId;
});
